import { useQuery } from 'hooks/useCustomQuery';
import { useEffect } from 'react';
import getCompanies from '@/API/Company/getCompanies';

/**
 * Custom hook to get companies data for the assignments page
 * This follows the modern React Query pattern without deprecated onSuccess
 */
const useGetAssignmentsCompanies = (
    currentPartner,
    requiredScope,
    setCompanies,
    enabled = true,
) => {
    const query = useQuery({
        queryKey: ['assignmentsCompanies', { requiredScope }],
        queryFn: () =>
            getCompanies(currentPartner, requiredScope).then((res) => res.data),
        enabled: enabled && !!currentPartner,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
    });

    // Handle data updates using useEffect instead of deprecated onSuccess
    useEffect(() => {
        if (query.data && setCompanies) {
            setCompanies(query.data);
        }
    }, [query.data, setCompanies]);

    return query;
};

export default useGetAssignmentsCompanies;
